module.exports = __webpack_public_path__ + "static/media/coding.dc9df6b4.png";